var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNerdwalletIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 37,
    viewBox: "0 0 30 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5263 0H0V35.4809C0 36.1655 0.690204 36.6345 1.32666 36.3824L14.1452 31.3051C14.3553 31.2219 14.5889 31.2203 14.8 31.3008L28.2117 36.4073C28.8463 36.6489 29.5263 36.1802 29.5263 35.5012V0Z",
    fill: "url(#paint0_linear_27_487)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3558 31.2501L0 25.2183V35.5772C0 36.2157 0.643709 36.653 1.23729 36.4179L14.1452 31.3053C14.2134 31.2782 14.2841 31.2598 14.3558 31.2501Z",
    fill: "#00682C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6467 31.623L0 25.2148V25.221L12.8463 31.8196L14.1452 31.305C14.3553 31.2218 14.5889 31.2203 14.8 31.3007L15.6467 31.623Z",
    fill: "#00482F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8895 7.30011C11.8402 7.28206 11.7872 7.27197 11.7337 7.27197H7.39073C7.21427 7.27197 7.07141 7.41483 7.07141 7.59123V12.1193V21.4957C7.07141 21.5833 7.1071 21.6635 7.16451 21.7218C7.22191 21.7791 7.30189 21.8149 7.39064 21.8149H11.5994C11.7758 21.8149 11.9187 21.6721 11.9187 21.4957V16.9677L11.9188 7.3131L11.8895 7.30011ZM16.7671 21.7738V12.1193V7.59014C16.7671 7.41483 16.9099 7.27197 17.0863 7.27197H21.2951C21.4715 7.27197 21.6143 7.41483 21.6143 7.59123V12.1204V16.9655L21.6155 16.9666L21.6144 16.9677V16.9687V21.4967C21.6144 21.6732 21.4716 21.816 21.2951 21.816H16.9521C16.898 21.816 16.8451 21.8052 16.7952 21.7868L16.7963 21.7857C16.7865 21.7825 16.7768 21.7782 16.7671 21.7738ZM11.9188 7.3131C11.9664 7.33475 12.0119 7.36506 12.0497 7.40294L16.7661 12.1193V21.7738C16.7184 21.7522 16.673 21.7219 16.6352 21.684L11.9187 16.9677L11.9188 7.3131Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_27_487",
    x1: 3.28801,
    y1: 2.87673,
    x2: 29.2742,
    y2: 15.9903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00682C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A9859"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNerdwalletIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/nerdwallet-icon.bcfc36865059e6caa07a0319dd6b6ea8.svg";